import { ref, type InjectionKey, type Ref } from 'vue';
import { defineStore } from 'pinia';

export type ViewMode = 'grid' | 'list';

// Provided by DocumentsLayout, so only files inside it follow the toggle. Files rendered elsewhere stay in grid mode.
export const viewModeKey: InjectionKey<Ref<ViewMode>> =
    Symbol('documentsViewMode');

export const useDocumentsLayoutStore = defineStore(
    'documentsLayoutStore',
    () => {
        const viewMode = ref<ViewMode>('grid');

        return {
            viewMode,
        };
    },
    {
        persist: {
            storage: window.sessionStorage,
        },
    }
);
